import React from "react";
import TitoloColore from "../commons/TitoloColore";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";
import SpaceL from "../commons/SpaceL";
import CaroselloStandard from "../commons/CaroselloStandard";
import foto1 from "../images/Cafe/IMG_9274.jpg"
import foto2 from "../images/Cafe/IMG_9279.jpg"
import foto3 from "../images/Cafe/IMG_9276.jpg"
import foto4 from "../images/Cafe/IMG_9282.jpg"
import piatto1 from "../images/Cafe/collage_piatti.jpg"
import CardInEvidenza from "../components/CardInEvidenza";
import barista from "../images/News/Barista.jpg";
import CardNews from "../components/CardNews";
import CardNewsEvidenza from "../components/CardNewsEvidenza";
import promo from "../images/News/Promo_fine_stagione.png";




function Cafe() {
    return(
        <div>

            <ScrollToTopOnMount />
            <TitoloColore title={"Il Cigno Café"} backgroundColor={"#003F83"} />
            <SpaceL />
            <div style={{padding: "1em"}}>
            <div className="table-container">
                <table className="table table-bordered m-auto" style={{width: "20em"}}>
                    <colgroup>
                        <col style={{ width: "14.287%", minWidth: "50px"}} />
                        <col style={{ width: "14.287%", minWidth: "50px" }} />
                    </colgroup>
                    <thead>
                    <tr>
                        <th className="header-cell" scope="col">Giorno</th>
                        <th className="header-cell" scope="col">Orario</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="data-cell">dal lunedì al venerdì</td>
                        <td className="data-cell">9-19.30</td>
                    </tr>
                    <tr>
                        <td className="data-cell">sabato</td>
                        <td className="data-cell">9-15</td>
                    </tr>
                    <tr>
                        <td className="data-cell">domenica</td>
                        <td className="data-cell">9-12.30</td>
                    </tr>
                    </tbody>
                </table>
                <SpaceL />
            </div>
            <SpaceL />
            <CaroselloStandard foto1={foto1} foto2={foto2} foto3={foto3} foto4={piatto1} />
                <Space />
                <div className="m-auto" style={{maxWidth: "90%"}}>
                    <p style={{fontSize: "32px", fontFamily: "Hammersmith One"}}>In evidenza</p>
                    <hr/>
                    <div className="d-none d-sm-block" >
                        <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
                            <CardInEvidenza foto={barista} titolo={"Il Cigno Café"} descrizione={""} data={"11.04.2024"} indirizzo={"../news/barista"} settore1={"ilcignocafé"} posizioneFoto={"top"}/>
                        </div>
                    </div>
                    <div className="d-sm-none  " >
                        <div className="card-container" style={{ display:"flex", flexDirection: "row" , overflowX: "auto" }}>
                            <CardNewsEvidenza foto={barista} titolo={"Il Cigno Café"} descrizione={""} data={"11.04.2024"} indirizzo={"../news/barista"} settore1={"ilcignocafé"} posizioneFoto={"top"}/>
                        </div>
                    </div>
                </div>
                <Space />
            </div>
        </div>
    )
}

export default Cafe